module.exports = __webpack_public_path__ + "static/media/bottle.f58c537d.png";